import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";

const WebsiteButton = ({ website }) => {
  return (
    <a
      href={website}
      target="_blank"
      rel="noopener noreferrer"
      className="icon-button"
    >
      <FontAwesomeIcon icon={faGlobe} />
    </a>
  );
};

export default WebsiteButton;
